import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BlogComponent } from "./blog.component";
import { SingleArticleComponent } from "./single-article/single-article.component";
import { ArticlePreviewComponent } from "./article-preview/article-preview.component";
import { BlogLayoutComponent } from "./blog.layout";
import { BlogRoutingModule } from "./blog.routing.module";
import { ThemeModule } from "../@theme/theme.module";
import { NbButtonModule, NbCardModule } from "@nebular/theme";
import { EditorModule } from "@tinymce/tinymce-angular";

@NgModule({
    declarations: [
        BlogComponent,
        SingleArticleComponent,
        ArticlePreviewComponent,
        BlogLayoutComponent,
    ],
    imports: [
        CommonModule,
        ThemeModule,
        BlogRoutingModule,
        NbCardModule,
        NbButtonModule,
        EditorModule,
    ],
})
export class BlogModule {}
